// ── i18n ──────────────────────────────────────────────────────────────────────
// Shopify cannot translate strings that live inside a JS asset, so the `noux`
// locale namespace is rendered into the page by snippets/noux-i18n.liquid and read
// here. Every call passes the original English as a fallback, so if that snippet is
// missing or fails to parse the output is byte-identical to before.
// Placeholders are %name% style (NOT {name}: Liquid errors on single braces inside
// string literals, e.g. replace: '{percent}') and are substituted below.
window.nouxT = (function () {
  var dict = {};
  try {
    var el = document.querySelector('[data-noux-i18n]');
    if (el) dict = JSON.parse(el.textContent) || {};
  } catch (e) { dict = {}; }
  return function (key, fallback, vars) {
    var s = dict[key];
    if (typeof s !== 'string' || s === '' || s.indexOf('translation missing') === 0) s = fallback;
    if (vars) {
      for (var k in vars) {
        if (Object.prototype.hasOwnProperty.call(vars, k)) s = s.split('%' + k + '%').join(vars[k]);
      }
    }
    return s;
  };
})();

// Store locale for number/currency formatting. Passing `undefined` to Intl uses the
// VISITOR'S BROWSER locale, so a Dutch shopper on an English-language browser saw
// "€17.95" instead of "€ 17,95". Shopify.locale is the storefront's locale.
function nouxLocale() {
  try { return (window.Shopify && Shopify.locale) || undefined; } catch (e) { return undefined; }
}

// ── shared design meta (colour group + effect) ──
// Both design pickers (the live bundle builder and the kit PDP) filter on the same buckets,
// so these live at file scope: one definition, no drift between the two drawers.
var NOUX_COLOURS = [['nude', 'Nude', '#e6c6a8'], ['pink', 'Pink', '#e39ab5'], ['red', 'Red', '#d02f2f'], ['berry', 'Berry', '#7a1f33'], ['purple', 'Purple', '#9d7bc0'], ['blue', 'Blue', '#7aa8d8'], ['green', 'Green', '#7f9b5a'], ['yellow', 'Yellow', '#e4cf63'], ['neutral', 'Neutral', '#c9bfb4'], ['white', 'Milk', '#f1ebe1'], ['black', 'Black', '#1a1311']];
var NOUX_EFFECTS = [['solid', 'Solid'], ['glitter', 'Glitter'], ['pattern', 'Pattern']];
function nouxHexHsl(hex) {
  var h = (hex || '#cccccc').replace('#', ''); if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
  var r = parseInt(h.substr(0, 2), 16) / 255, g = parseInt(h.substr(2, 2), 16) / 255, b = parseInt(h.substr(4, 2), 16) / 255;
  var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, s = 0, hue = 0, d = mx - mn;
  if (d) { s = l > 0.5 ? d / (2 - mx - mn) : d / (mx + mn); if (mx === r) hue = ((g - b) / d + (g < b ? 6 : 0)); else if (mx === g) hue = (b - r) / d + 2; else hue = (r - g) / d + 4; hue *= 60; }
  return { h: hue, s: s, l: l };
}
function nouxColourOf(s) {
  var c = nouxHexHsl(s.hex), h = c.h, sat = c.s, l = c.l;
  if (l <= 0.16) return 'black';
  if (l >= 0.9 && sat <= 0.2) return 'white';
  if (sat <= 0.14) return 'neutral';
  if (h < 15 || h >= 340) return l < 0.4 ? 'berry' : 'red';
  if (h < 45) return 'nude';
  if (h < 66) return 'yellow';
  if (h < 160) return 'green';
  if (h < 255) return 'blue';
  if (h < 300) return 'purple';
  return 'pink';
}
function nouxEffectOf(s) {
  if (s.effect) return String(s.effect).toLowerCase();
  var n = (s.name || '').toLowerCase();
  if (/glitter|glitz|champagne|galaxy|chrome|sparkle|shimmer|disco|stardust|metallic/.test(n)) return 'glitter';
  if (/marble|french|carrara|ombre|swirl|boomer|tip|happy hour|jade|abstract|dot/.test(n)) return 'pattern';
  return 'solid';
}
// Tag a shade list in place with its filter buckets.
function nouxTagShades(list) {
  (list || []).forEach(function (s) {
    s._c = (s.colour ? String(s.colour).toLowerCase() : nouxColourOf(s));
    s._e = nouxEffectOf(s);
  });
  return list;
}

// Noux interactive bits — hero slider, bestseller tabs, FAQ accordion
(function () {
  // Currency symbol for the visitor's active presentment currency (GBP base, AUD/EUR/… via Markets).
  // Falls back to whatever the theme rendered into data-currency.
  function nouxCurSymbol(fallback) {
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    if (!code) return fallback || '£';
    try {
      var parts = new Intl.NumberFormat(nouxLocale(), {
        style: 'currency', currency: code, currencyDisplay: 'narrowSymbol'
      }).formatToParts(0);
      for (var i = 0; i < parts.length; i++) if (parts[i].type === 'currency') return parts[i].value;
    } catch (e) {}
    return fallback || '£';
  }

  // Hero slider
  document.querySelectorAll('[data-noux-hero]').forEach(function (root) {
    var slides = root.querySelectorAll('.nh-hero-slide');
    var dots = root.querySelectorAll('.nh-hero-dot');
    var counter = root.querySelector('[data-hero-count]');
    var total = slides.length;
    var idx = 0;
    function go(n) {
      idx = (n + total) % total;
      slides.forEach(function (s, i) { s.classList.toggle('active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
      if (counter) counter.textContent = String(idx + 1).padStart(2, '0');
    }
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    go(0);
  });

  // Bestseller tabs
  document.querySelectorAll('[data-noux-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('.nh-best-tab');
    var panels = root.querySelectorAll('.nh-best-panel');
    function activate(id) {
      tabs.forEach(function (t) { t.classList.toggle('active', t.dataset.tab === id); });
      panels.forEach(function (p) { p.classList.toggle('active', p.dataset.panel === id); });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { activate(t.dataset.tab); }); });
    if (tabs[0]) activate(tabs[0].dataset.tab);
  });

  // FAQ accordion
  document.querySelectorAll('[data-noux-faq]').forEach(function (root) {
    var items = root.querySelectorAll('.nh-faq-item');
    items.forEach(function (item, i) {
      item.addEventListener('click', function () {
        var wasOpen = item.classList.contains('open');
        items.forEach(function (x) { x.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
      if (i === 0) item.classList.add('open');
    });
  });
})();

// Product page interactions
(function () {
  // Legacy variant swatch picker (kept for non-bundle products)
  document.querySelectorAll('[data-noux-variants]').forEach(function (root) {
    var swatches = root.querySelectorAll('[data-variant-id]');
    var label = root.querySelector('[data-variant-label]');
    var input = document.querySelector('[data-noux-variant-input]');
    swatches.forEach(function (s) {
      s.addEventListener('click', function () {
        swatches.forEach(function (x) { x.classList.remove('active'); });
        s.classList.add('active');
        if (label) label.textContent = s.dataset.variantLabel || '';
        if (input) input.value = s.dataset.variantId;
        if (s.dataset.variantImage) window.nouxSwapMainImage(s.dataset.variantImage, s.dataset.variantLabel);
      });
    });
  });

  // Swap the gallery main image (used by swatch picker + bundle builder). Handles video too.
  window.nouxSwapMainImage = function (url, alt, isVideo) {
    var wrap = document.querySelector('[data-noux-main-img]');
    if (!wrap || !url) return;
    var ph = wrap.querySelector('.imgph-label');
    if (ph) ph.remove();
    var isVid = isVideo || /\.(mp4|webm|mov)(\?|$)/i.test(url);
    var existingImg = wrap.querySelector('img');
    var existingVid = wrap.querySelector('video.np-main-video');
    if (isVid) {
      if (existingImg) existingImg.style.display = 'none';
      var v = existingVid;
      if (!v) {
        v = document.createElement('video');
        v.className = 'np-main-video';
        v.muted = true; v.loop = true; v.autoplay = true;
        v.setAttribute('playsinline', ''); v.playsInline = true;
        wrap.appendChild(v);
      }
      v.style.display = '';
      if (v.getAttribute('src') !== url) v.src = url;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      return;
    }
    if (existingVid) { existingVid.pause(); existingVid.style.display = 'none'; }
    var img = existingImg;
    if (!img) { img = document.createElement('img'); wrap.appendChild(img); }
    img.style.display = '';
    img.removeAttribute('srcset');
    img.src = url;
    if (alt) img.alt = alt;
  };

  // Show the floating trust badge only on the first/default image (no gallery thumbnail active),
  // and never once it's been dismissed via its × button.
  window.nouxTopBadgeSync = function () {
    var b = document.querySelector('[data-noux-topbadge]');
    if (!b) return;
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('nouxTopBadgeClosed') === '1'; } catch (e) {}
    var thumbs = document.querySelectorAll('[data-noux-thumb]');
    var firstActive = thumbs.length ? thumbs[0].classList.contains('active') : true;
    b.style.display = (dismissed || !firstActive) ? 'none' : '';
  };

  // ── Gallery thumbnails: tap to swap main image, arrows to step, tap main to advance ──
  (function () {
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-noux-thumb]'));
    if (!thumbs.length) return;
    function activate(t) {
      if (!t) return;
      thumbs.forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      if (t.dataset.full) window.nouxSwapMainImage(t.dataset.full, t.dataset.alt || '');
      t.scrollIntoView({ block: 'nearest', inline: 'center' });
      if (window.nouxTopBadgeSync) window.nouxTopBadgeSync();
    }
    function curIdx() { for (var i = 0; i < thumbs.length; i++) { if (thumbs[i].classList.contains('active')) return i; } return 0; }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { activate(t); }); });
    var prev = document.querySelector('[data-noux-thumb-prev]');
    var next = document.querySelector('[data-noux-thumb-next]');
    if (prev) prev.addEventListener('click', function () { activate(thumbs[(curIdx() - 1 + thumbs.length) % thumbs.length]); });
    if (next) next.addEventListener('click', function () { activate(thumbs[(curIdx() + 1) % thumbs.length]); });
    var main = document.querySelector('[data-noux-main-img]');
    if (main) main.addEventListener('click', function () { activate(thumbs[(curIdx() + 1) % thumbs.length]); });
  })();

  // ── Tiered bundle builder (01 set · 02 slots · add-more-designs · picker drawer) ──
  (function () {
    var dataEl = document.querySelector('[data-noux-bundle-data]');
    var bundle = document.querySelector('[data-noux-bundle]');
    if (!dataEl || !bundle) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var tiers = data.tiers || [];
    if (!tiers.length) return;

    var tiersWrap = bundle.querySelector('[data-noux-tiers]');
    var slotsWrap = bundle.querySelector('[data-noux-slots]');
    var countEl = bundle.querySelector('[data-noux-count]');
    var extraBox = bundle.querySelector('[data-noux-extra]');
    var extraSlotsWrap = bundle.querySelector('[data-noux-extra-slots]');
    var extraCountEl = bundle.querySelector('[data-noux-extra-count]');
    var extraBadgeEl = bundle.querySelector('[data-noux-extra-badge]');
    var extraUnitEl = bundle.querySelector('[data-noux-extra-unit]');
    var form = document.getElementById('noux-product-form');
    var input = document.querySelector('[data-noux-variant-input]');
    var propsWrap = form ? form.querySelector('[data-noux-props]') : null;
    var addBtn = form ? form.querySelector('[data-noux-add]') : null;
    var hint = form ? form.querySelector('[data-noux-bundle-hint]') : null;
    var priceEl = document.querySelector('[data-noux-price]');
    var strikeEl = document.querySelector('[data-noux-strike]');
    var saveEl = document.querySelector('[data-noux-save]');
    var ctaPrice = document.querySelector('[data-noux-cta-price]');
    var ctaStrike = document.querySelector('[data-noux-cta-strike]');
    var drawer = document.querySelector('[data-noux-drawer]');
    var drawerGrid = drawer ? drawer.querySelector('[data-noux-drawer-grid]') : null;
    var drawerNum = drawer ? drawer.querySelector('[data-noux-drawer-num]') : null;
    var drawerFilters = drawer ? drawer.querySelector('[data-noux-drawer-filters]') : null;
    var drawerBody = drawer ? drawer.querySelector('[data-noux-drawer-body]') : null;
    var previewWrap = drawer ? drawer.querySelector('[data-noux-preview]') : null;
    var previewBack = drawer ? drawer.querySelector('[data-noux-preview-back]') : null;

    // Format in the visitor's active presentment currency (AUD, EUR, USD, …) — Shopify converts the amounts,
    // we just show the right symbol + code instead of a hard-coded "AUD".
    var CUR_CODE = (window.Shopify && Shopify.currency && Shopify.currency.active) || data.currencyCode || 'GBP';
    var CUR_NF = null;
    try { CUR_NF = new Intl.NumberFormat(nouxLocale(), { style: 'currency', currency: CUR_CODE, currencyDisplay: 'narrowSymbol' }); }
    catch (e) { try { CUR_NF = new Intl.NumberFormat(nouxLocale(), { style: 'currency', currency: CUR_CODE }); } catch (e2) { CUR_NF = null; } }
    function curSym(cents) {
      var a = cents / 100;
      if (CUR_NF) { try { return CUR_NF.format(a); } catch (e) {} }
      return (data.currency || '£') + a.toFixed(2);
    }
    // Append the ISO code ONLY when the symbol is ambiguous: "$" is shared by AUD/USD/CAD/NZD, so an
    // AU visitor needs "$105.90 AUD". "£" and "€" stand alone — never "£54.90 GBP". And when the symbol
    // already IS the code ("MKD 19.20") don't double it up.
    function needsCode(s) { return s.indexOf(CUR_CODE) === -1 && s.indexOf('$') !== -1; }
    function fmt(cents) { var s = curSym(cents); return needsCode(s) ? (s + ' ' + CUR_CODE) : s; }
    function fmtPlain(cents) { return curSym(cents); }
    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
    var maxTotal = 1;
    data.variants.forEach(function (v) { var m = String(v.size).match(/\d+/); if (m) maxTotal = Math.max(maxTotal, parseInt(m[0], 10)); });

    function sizeNameFor(n) {
      var found = null;
      data.variants.forEach(function (v) {
        var m = String(v.size).match(/\d+/);
        if (m && parseInt(m[0], 10) === n) found = v.size;
      });
      return found;
    }
    function variantForCount(n) {
      var size = sizeNameFor(n);
      return data.variants.find(function (v) { return v.size === size && v.available; }) ||
             data.variants.find(function (v) { return v.size === size; });
    }
    function shadeByName(name) { return data.shades.find(function (x) { return x.name === name; }); }

    function tierMeta(t) {
      var count = t.count, freeFrom = t.freeFrom || 0;
      var paid = freeFrom > 0 ? Math.max(freeFrom - 1, 0) : count;
      var free = Math.max(count - paid, 0);
      var label = free > 0
        ? nouxT(free === 1 ? 'free_design_one' : 'free_design_other',
                paid + '+' + free + ' free design' + (free === 1 ? '' : 's'), { paid: paid, free: free })
        : nouxT(count === 1 ? 'design_count_one' : 'design_count_other',
                count + (count === 1 ? ' design' : ' designs'), { count: count });
      return { count: count, freeFrom: freeFrom, paid: paid, free: free, label: label };
    }

    var selTier = (data.defaultTier != null) ? Math.min(Math.max(data.defaultTier, 0), tiers.length - 1) : 0;
    var picks = [];   // tier designs
    var extras = [];  // extra designs (separate add-on line items, priced per tier %off)
    var EXTRA_MAX = 12;

    function tierPctFor(t) {
      var v = variantForCount(t.count);
      if (!v) return 0;
      var price = v.price, cap = (v.cap && v.cap > price) ? v.cap : 0;
      return cap ? Math.round((cap - price) / cap * 100) : 0;
    }
    function extraForTier() { return (data.extraVariants || [])[selTier] || null; }
    var drawerTarget = null; // {type:'main'|'extra', idx}

    function inclCountFor(t) {
      var inc = data.included || [];
      var n = (t && t.incl > 0) ? t.incl : inc.length;
      return Math.min(n, inc.length);
    }
    function inclHtml(t) {
      var inc = data.included || [];
      if (!inc.length) return '';
      var n = inclCountFor(t);
      var chips = inc.slice(0, Math.min(2, n)).map(function (it) { return '<span class="np-tier-chip">' + esc(it.name) + '</span>'; }).join('');
      if (n > 2) chips += '<span class="np-tier-chip np-tier-chip-more" data-noux-incl-more role="button" tabindex="0">' + nouxT('incl_more', '+' + (n - 2) + ' more', { count: n - 2 }) + '</span>';
      return '<span class="np-tier-incl">'
        + '<span class="np-tier-incl-label">' + esc(data.inclLabel || 'Included') + '</span>'
        + '<span class="np-tier-chips">' + chips + '</span></span>';
    }
    function renderWyg() {
      var wygGrid = document.querySelector('[data-noux-wyg-grid]');
      if (!wygGrid) return;
      var inc = data.included || [];
      var n = inclCountFor(tiers[selTier]);   // show only the accessories included in the selected tier
      wygGrid.innerHTML = inc.slice(0, n).map(function (it) {
        var media = it.img
          ? '<img src="' + it.img + '" alt="' + esc(it.name) + '" loading="lazy">'
          : '<span class="np-wyg-ph" aria-hidden="true"></span>';
        return '<div class="np-wyg-card" role="button" tabindex="0"><div class="np-wyg-img imgph">' + media + '<span class="np-wyg-info" aria-hidden="true">i</span></div><span class="np-wyg-name">' + esc(it.name) + '</span></div>';
      }).join('');
    }

    function renderTiers() {
      if (!tiersWrap) return;
      var html = '';
      tiers.forEach(function (t, i) {
        var v = variantForCount(t.count);
        if (!v) return;
        var meta = tierMeta(t);
        var price = v.price, cap = (v.cap && v.cap > price) ? v.cap : 0;
        var pct = cap ? Math.round((cap - price) / cap * 100) : 0;
        html += '<button type="button" class="np-tier' + (i === selTier ? ' active' : '') + '" data-noux-tier="' + i + '">'
          + (t.tag ? '<span class="np-tier-tag">' + esc(t.tag) + '</span>' : '')
          + '<span class="np-tier-row">'
          + '<span class="np-tier-radio"></span>'
          + '<span class="np-tier-name">' + esc(t.name) + '</span>'
          + '<span class="np-tier-count">' + meta.label + '</span>'
          + '<span class="np-tier-price">'
          + (pct ? '<span class="np-tier-pct">-' + pct + '%</span>' : '')
          + '<span class="np-tier-price-stack">'
          + (cap ? '<s>' + fmtPlain(cap) + '</s>' : '')
          + '<strong>' + fmt(price) + '</strong></span></span>'
          + '</span>'
          + inclHtml(t)
          + '</button>';
      });
      tiersWrap.innerHTML = html;
    }

    function slotHtml(kind, i, isFree, pick) {
      var shade = pick ? shadeByName(pick) : null;
      var fill = shade ? (shade.img ? ('background:url(' + shade.img + ') center/cover no-repeat') : ('background:' + shade.hex)) : '';
      var attr = kind === 'extra' ? 'data-noux-extra-slot' : 'data-noux-slot';
      var rmAttr = kind === 'extra' ? 'data-noux-extra-remove' : 'data-noux-slot-remove';
      var label = kind === 'extra'
        ? (pick ? esc(pick) : nouxT('slot_extra', 'Extra ' + i, { n: i }))
        : (pick ? esc(pick) : nouxT('slot_design', 'Design ' + i, { n: i }));
      return '<div class="np-slot-wrap">'
        + (isFree ? '<span class="np-slot-free">' + nouxT('free_badge', 'FREE') + '</span>' : '')
        + '<div class="np-slot-box">'
        + '<button type="button" class="np-slot' + (kind === 'extra' ? ' np-slot--round' : '') + (pick ? ' filled' : '') + '" ' + attr + '="' + i + '" aria-label="' + nouxT('a11y_choose_design', 'Choose design') + '">'
        + (pick ? ('<span class="np-slot-fill" style="' + fill + '"></span>') : '<span class="np-slot-plus" aria-hidden="true">+</span>')
        + '</button>'
        + (pick ? ('<button type="button" class="np-slot-x" ' + rmAttr + '="' + i + '" aria-label="' + nouxT('a11y_remove', 'Remove') + '">×</button>') : '')
        + '</div>'
        + '<span class="np-slot-label">' + label + '</span>'
        + '</div>';
    }

    function renderSlots() {
      if (!slotsWrap) return;
      var t = tiers[selTier], meta = tierMeta(t), html = '';
      var cols = t.count === 1 ? 3 : (t.count <= 4 ? t.count : 3);
      slotsWrap.style.gridTemplateColumns = 'repeat(' + cols + ', 1fr)';
      for (var i = 1; i <= t.count; i++) {
        var isFree = meta.freeFrom > 0 && i >= meta.freeFrom;
        html += slotHtml('main', i, isFree, picks[i - 1]);
      }
      slotsWrap.innerHTML = html;
    }

    function renderExtras() {
      if (!extraBox || !extraSlotsWrap) return;
      var ev = extraForTier();
      if (!ev || !ev.id) { extraBox.hidden = true; extras = []; return; }   // no add-on configured
      extraBox.hidden = false;
      if (extras.length > EXTRA_MAX) extras = extras.slice(0, EXTRA_MAX);
      var extraNormal = data.extraNormal || 1490;
      var pct = (extraNormal > ev.price) ? Math.round((extraNormal - ev.price) / extraNormal * 100) : 0;
      if (extraBadgeEl) extraBadgeEl.textContent = pct ? ('-' + pct + '%') : '';
      if (extraUnitEl) extraUnitEl.textContent = nouxT('per_design', fmt(ev.price) + ' per design · normally ' + fmtPlain(extraNormal), { price: fmt(ev.price), normal: fmtPlain(extraNormal) });
      // Drawer subtitle carries a %price% token so the per-design price follows the
      // visitor's presentment currency instead of being frozen as GBP in the copy.
      var dsubEl = document.querySelector('[data-noux-drawer-sub]');
      if (dsubEl && dsubEl.textContent.indexOf('%price%') !== -1) {
        dsubEl.textContent = dsubEl.textContent.split('%price%').join(fmtPlain(extraNormal));
      }
      var html = '';
      extras.forEach(function (name, i) { html += slotHtml('extra', i + 1, false, name); });
      if (extras.length < EXTRA_MAX) {
        html += '<div class="np-slot-wrap"><div class="np-slot-box">'
          + '<button type="button" class="np-slot np-slot--round np-slot--add" data-noux-extra-add aria-label="' + nouxT('a11y_add_another', 'Add another design') + '">'
          + '<span class="np-slot-plus" aria-hidden="true">+</span></button></div>'
          + '<span class="np-slot-label">' + nouxT('slot_add', 'Add') + '</span></div>';
      }
      extraSlotsWrap.innerHTML = html;
      if (extraCountEl) extraCountEl.textContent = extras.length;
    }

    function render() {
      var t = tiers[selTier];
      if (picks.length > t.count) picks = picks.slice(0, t.count);
      if (extras.length > EXTRA_MAX) extras = extras.slice(0, EXTRA_MAX);

      renderTiers();
      renderSlots();
      renderExtras();
      renderWyg();

      var v = variantForCount(t.count);   // base kit variant only; extras are separate line items
      var ev = extraForTier();
      var extraUnit = ev ? ev.price : 0;
      var extrasTotal = extras.length * extraUnit;
      var extrasCap = extras.length * (data.extraNormal || 1490);
      var n = picks.filter(Boolean).length;
      if (countEl) countEl.textContent = nouxT('selected', n + ' of ' + t.count + ' selected', { n: n, total: t.count });

      if (v) {
        var basePrice = v.price, baseCap = (v.cap && v.cap > basePrice) ? v.cap : basePrice;
        var price = basePrice + extrasTotal;
        var capTotal = baseCap + extrasCap;
        var hasSave = capTotal > price;
        if (priceEl) priceEl.textContent = fmt(price);
        if (strikeEl) { strikeEl.textContent = hasSave ? fmt(capTotal) : ''; strikeEl.style.display = hasSave ? '' : 'none'; }
        if (saveEl) {
          if (hasSave) { saveEl.style.display = ''; saveEl.textContent = data.savingsLabel + ' ' + fmt(capTotal - price); }
          else saveEl.style.display = 'none';
        }
        if (ctaPrice) ctaPrice.textContent = fmt(price);
        if (ctaStrike) { ctaStrike.textContent = hasSave ? fmt(capTotal) : ''; ctaStrike.style.display = hasSave ? '' : 'none'; }
        if (input) input.value = v.id;
      }

      if (propsWrap) {
        propsWrap.innerHTML = '';
        var setInp = document.createElement('input');
        setInp.type = 'hidden'; setInp.name = 'properties[Set]';
        setInp.value = t.name + ' · ' + t.count + (t.count === 1 ? ' design' : ' designs') + (extras.length ? (' + ' + extras.length + ' extra') : '');
        propsWrap.appendChild(setInp);
        picks.forEach(function (pick, i) {
          if (!pick) return;
          var inp = document.createElement('input');
          inp.type = 'hidden'; inp.name = 'properties[Design ' + (i + 1) + ']'; inp.value = pick;
          propsWrap.appendChild(inp);
        });
      }

      // Keep the button clickable even with no design; the submit handler shows a pop-up instead.
      if (hint) {
        var left = t.count - picks.filter(Boolean).length;
        hint.hidden = left <= 0;
        if (left > 0) hint.textContent = nouxT(left === 1 ? 'pick_more_one' : 'pick_more_other', 'Pick ' + left + ' more design' + (left === 1 ? '' : 's') + ' to continue.', { count: left });
      }
    }

    // Filter buckets come from the shared file-scope helpers so this drawer and the
    // kit PDP drawer always bucket a design identically.
    var COLOURS = NOUX_COLOURS, EFFECTS = NOUX_EFFECTS;
    nouxTagShades(data.shades);
    var fColour = null, fEffect = null;
    var previewIdx = 0, previewShadeI = -1;

    function renderFilters() {
      if (!drawerFilters) return;
      var shades = data.shades || [], cP = {}, eP = {};
      shades.forEach(function (s) { cP[s._c] = 1; eP[s._e] = 1; });
      var c = '<span class="np-df-label">' + nouxT('filter_colour', 'Colour') + '</span><span class="np-df-row">';
      COLOURS.forEach(function (x) { if (cP[x[0]]) c += '<button type="button" class="np-df-colour' + (fColour === x[0] ? ' active' : '') + '" data-noux-fcolour="' + x[0] + '" title="' + x[1] + '" style="background:' + x[2] + '"></button>'; });
      c += '</span>';
      var e = '<span class="np-df-label">' + nouxT('filter_effect', 'Effect') + '</span><span class="np-df-row">';
      EFFECTS.forEach(function (x) { if (eP[x[0]]) e += '<button type="button" class="np-df-effect' + (fEffect === x[0] ? ' active' : '') + '" data-noux-feffect="' + x[0] + '">' + nouxT('effect_' + x[0], x[1]) + '</button>'; });
      e += '</span>';
      drawerFilters.innerHTML = '<div class="np-df-group">' + c + '</div><div class="np-df-group">' + e + '</div>';
    }

    function renderDrawerGrid() {
      if (!drawerGrid) return;
      var current = drawerTarget && drawerTarget.type === 'extra' ? extras[drawerTarget.idx - 1] : (drawerTarget ? picks[drawerTarget.idx - 1] : null);
      var shades = (data.shades || []).filter(function (s) {
        if (fColour && s._c !== fColour) return false;
        if (fEffect && s._e !== fEffect) return false;
        return true;
      });
      if (!shades.length) { drawerGrid.innerHTML = '<p class="np-drawer-empty">' + nouxT('no_match', 'No designs match these filters.') + '</p>'; return; }
      drawerGrid.innerHTML = shades.map(function (shade) {
        var i = (data.shades || []).indexOf(shade);
        var soldOut = shade.available === false;
        var media = shade.img
          ? '<span class="np-drawer-tile-media"><img class="np-drawer-tile-img" src="' + shade.img + '" alt="' + esc(shade.name) + '" loading="lazy">' + (soldOut ? '<span class="np-drawer-tile-out">Sold out</span>' : '') + '</span>'
          : '<span class="np-drawer-tile-media"><span class="np-drawer-tile-swatch" style="background:' + shade.hex + '"></span></span>';
        var badge = '';
        if (soldOut) badge = '<span class="np-drawer-tile-stock out">' + nouxT('sold_out', 'Sold out') + '</span>';
        else if (shade.badge) {
          // Badges come from a product metafield in English; route them through the
          // locale namespace so NL shows "NIEUW" rather than "JUST ADDED".
          var bslug = String(shade.badge).toLowerCase().replace(/\s+/g, '_');
          badge = '<span class="np-drawer-tile-badge np-drawer-tile-badge--' + (bslug.indexOf('just') === 0 ? 'new' : 'best') + '">' + esc(nouxT('badge_' + bslug, shade.badge)) + '</span>';
        }
        return '<div class="np-drawer-cell' + (current === shade.name ? ' active' : '') + (soldOut ? ' sold-out' : '') + '">'
          + '<button type="button" class="np-drawer-tile" data-noux-pick="' + i + '"' + (soldOut ? ' disabled' : '') + '>'
          + media
          + badge
          + '<span class="np-drawer-tile-name">' + esc(shade.name) + '</span></button>'
          + '<button type="button" class="np-drawer-preview-btn" data-noux-prev="' + i + '"><span class="np-drawer-prev-ic" aria-hidden="true">⌕</span> ' + nouxT('preview', 'Preview') + '</button>'
          + '</div>';
      }).join('');
    }

    function pickShade(i) {
      var shade = (data.shades || [])[i]; if (!shade || shade.available === false || !drawerTarget) return;
      if (drawerTarget.type === 'extra') extras[drawerTarget.idx - 1] = shade.name; else picks[drawerTarget.idx - 1] = shade.name;
      closeDrawer(); render();
    }

    function openPreview(i) {
      var s = (data.shades || [])[i]; if (!s || !previewWrap) return;
      previewShadeI = i; previewIdx = 0;
      var imgs = (s.imgs && s.imgs.length) ? s.imgs : [s.img];
      var slides = imgs.map(function (u, k) { return '<div class="np-pv-slide' + (k === 0 ? ' on' : '') + '"><img src="' + u + '" alt="' + esc(s.name) + '" loading="lazy"></div>'; }).join('');
      var dots = imgs.length > 1 ? imgs.map(function (u, k) { return '<button type="button" class="np-pv-dot' + (k === 0 ? ' on' : '') + '" data-noux-pvdot="' + k + '"></button>'; }).join('') : '';
      previewWrap.innerHTML =
        '<div class="np-pv-stage">'
        + (imgs.length > 1 ? '<button type="button" class="np-pv-arrow prev" data-noux-pvprev aria-label="' + nouxT('prev', 'Previous') + '">‹</button>' : '')
        + '<div class="np-pv-slides">' + slides + '</div>'
        + (imgs.length > 1 ? '<button type="button" class="np-pv-arrow next" data-noux-pvnext aria-label="' + nouxT('next', 'Next') + '">›</button>' : '')
        + '</div>'
        + (dots ? '<div class="np-pv-dots">' + dots + '</div>' : '')
        + '<h3 class="np-pv-name">' + esc(s.name) + '</h3>'
        + (s.desc ? '<p class="np-pv-desc">' + esc(s.desc) + '</p>' : '')
        + '<button type="button" class="np-pv-select" data-noux-pvselect>' + nouxT('pv_select', '+ Select this design') + '</button>';
      if (drawerBody) drawerBody.hidden = true;
      previewWrap.hidden = false;
      if (previewBack) previewBack.hidden = false;
      previewWrap.scrollTop = 0;
    }
    function updatePreview() {
      if (previewShadeI < 0) return;
      var s = (data.shades || [])[previewShadeI];
      var imgs = (s.imgs && s.imgs.length) ? s.imgs : [s.img];
      if (previewIdx < 0) previewIdx = imgs.length - 1;
      if (previewIdx >= imgs.length) previewIdx = 0;
      previewWrap.querySelectorAll('.np-pv-slide').forEach(function (el, k) { el.classList.toggle('on', k === previewIdx); });
      previewWrap.querySelectorAll('.np-pv-dot').forEach(function (el, k) { el.classList.toggle('on', k === previewIdx); });
    }
    function closePreview() {
      if (previewWrap) previewWrap.hidden = true;
      if (drawerBody) drawerBody.hidden = false;
      if (previewBack) previewBack.hidden = true;
      previewShadeI = -1;
    }

    function openDrawer(target) {
      if (!drawer) return;
      drawerTarget = target;
      if (drawerNum) drawerNum.textContent = target.type === 'extra' ? nouxT('drawer_extra', '· Extra design') : nouxT('drawer_design', '· Design ' + target.idx, { n: target.idx });
      closePreview();
      renderFilters();
      renderDrawerGrid();
      drawer.hidden = false;
      document.documentElement.classList.add('np-drawer-open');
    }
    function closeDrawer() {
      if (!drawer) return;
      closePreview();
      drawer.hidden = true;
      document.documentElement.classList.remove('np-drawer-open');
    }

    if (drawerFilters) drawerFilters.addEventListener('click', function (e) {
      var c = e.target.closest('[data-noux-fcolour]');
      if (c) { var v = c.getAttribute('data-noux-fcolour'); fColour = (fColour === v) ? null : v; renderFilters(); renderDrawerGrid(); return; }
      var ef = e.target.closest('[data-noux-feffect]');
      if (ef) { var w = ef.getAttribute('data-noux-feffect'); fEffect = (fEffect === w) ? null : w; renderFilters(); renderDrawerGrid(); return; }
    });
    if (drawerGrid) drawerGrid.addEventListener('click', function (e) {
      var pv = e.target.closest('[data-noux-prev]'); if (pv) { openPreview(parseInt(pv.getAttribute('data-noux-prev'), 10)); return; }
      var pk = e.target.closest('[data-noux-pick]'); if (pk) { pickShade(parseInt(pk.getAttribute('data-noux-pick'), 10)); return; }
    });
    if (previewWrap) previewWrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-noux-pvprev]')) { previewIdx--; updatePreview(); return; }
      if (e.target.closest('[data-noux-pvnext]')) { previewIdx++; updatePreview(); return; }
      var dot = e.target.closest('[data-noux-pvdot]'); if (dot) { previewIdx = parseInt(dot.getAttribute('data-noux-pvdot'), 10); updatePreview(); return; }
      if (e.target.closest('[data-noux-pvselect]')) { pickShade(previewShadeI); return; }
    });
    if (previewBack) previewBack.addEventListener('click', closePreview);

    // tier select
    if (tiersWrap) tiersWrap.addEventListener('click', function (e) {
      var more = e.target.closest('[data-noux-incl-more]');
      if (more) {
        e.stopPropagation();
        var tb = more.closest('[data-noux-tier]');
        var chipsWrap = more.closest('.np-tier-chips');
        if (tb && chipsWrap) {
          var ti = parseInt(tb.getAttribute('data-noux-tier'), 10);
          var inc = data.included || [];
          var nn = inclCountFor(tiers[ti]);
          chipsWrap.innerHTML = inc.slice(0, nn).map(function (it) { return '<span class="np-tier-chip">' + esc(it.name) + '</span>'; }).join('');
        }
        return;
      }
      var c = e.target.closest('[data-noux-tier]');
      if (!c) return;
      selTier = parseInt(c.getAttribute('data-noux-tier'), 10);
      render();
      swapTierImage();
    });

    // main slots
    if (slotsWrap) slotsWrap.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-noux-slot-remove]');
      if (rm) { e.stopPropagation(); var ri = parseInt(rm.getAttribute('data-noux-slot-remove'), 10); if (ri >= 1 && ri <= picks.length) { picks.splice(ri - 1, 1); render(); } return; }
      var s = e.target.closest('[data-noux-slot]');
      if (s) { var idx = parseInt(s.getAttribute('data-noux-slot'), 10); openDrawer({ type: 'main', idx: Math.min(idx, picks.length + 1) }); }
    });

    // extra slots
    if (extraSlotsWrap) extraSlotsWrap.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-noux-extra-remove]');
      if (rm) { e.stopPropagation(); var ri = parseInt(rm.getAttribute('data-noux-extra-remove'), 10); if (ri >= 1 && ri <= extras.length) { extras.splice(ri - 1, 1); render(); } return; }
      if (e.target.closest('[data-noux-extra-add]')) { openDrawer({ type: 'extra', idx: extras.length + 1 }); return; }
      var s = e.target.closest('[data-noux-extra-slot]');
      if (s) { var idx = parseInt(s.getAttribute('data-noux-extra-slot'), 10); openDrawer({ type: 'extra', idx: idx }); }
    });

    if (drawer) {
      drawer.querySelectorAll('[data-noux-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    }

    // ── Add-to-cart: require ALL designs picked, else prompt (Sassy Saints style) ──
    var atcPop = document.querySelector('[data-noux-atc-pop]');
    var atcPopTitle = atcPop ? atcPop.querySelector('.np-atc-pop-title') : null;
    var atcPopBody = atcPop ? atcPop.querySelector('.np-atc-pop-body') : null;
    function closeAtcPop() { if (atcPop) { atcPop.hidden = true; document.documentElement.classList.remove('np-drawer-open'); } }
    function firstEmptySlot(t) { for (var i = 0; i < t.count; i++) { if (!picks[i]) return i + 1; } return t.count; }
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var t = tiers[selTier];
      if (picks.filter(Boolean).length < t.count) {
        var remaining = t.count - picks.filter(Boolean).length;
        if (atcPopTitle) atcPopTitle.textContent = picks.filter(Boolean).length === 0 ? nouxT('pick_first', 'Pick your designs first') : nouxT('almost_there', 'Almost there!');
        if (atcPopBody) atcPopBody.textContent = nouxT('pick_body', 'Please choose all ' + t.count + ' designs for your kit. ' + remaining + ' still to pick.', { total: t.count, remaining: remaining });
        if (atcPop) { atcPop.hidden = false; document.documentElement.classList.add('np-drawer-open'); }
        return;
      }
      var baseV = variantForCount(t.count);
      if (!baseV) return;
      var setLabel = t.name + ' · ' + t.count + (t.count === 1 ? ' design' : ' designs') + (extras.length ? (' + ' + extras.length + ' extra') : '');
      var baseProps = { 'Set': setLabel };
      picks.forEach(function (p, i) { if (p) baseProps['Design ' + (i + 1)] = p; });
      var items = [{ id: baseV.id, quantity: 1, properties: baseProps }];
      var ev = extraForTier();
      if (ev && ev.id) {
        extras.forEach(function (name) {
          items.push({ id: ev.id, quantity: 1, properties: { 'Extra design': name || 'Chosen at checkout' } });
        });
      }
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('disabled', 'disabled');
      // Clear the cart first so a new selection replaces any previous kit/config
      // (prevents stacked Starter Kit configurations piling up in the cart).
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
      }).then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, j: j }; });
      }).then(function (res) {
        if (!res.ok) { if (btn) btn.removeAttribute('disabled'); alert((res.j && res.j.description) || 'Sorry, could not add to cart.'); return; }
        window.location.href = '/checkout';
      }).catch(function () {
        if (btn) btn.removeAttribute('disabled');
        alert('Network error. Please try again.');
      });
    });
    if (atcPop) {
      atcPop.querySelectorAll('[data-noux-atc-close]').forEach(function (b) { b.addEventListener('click', closeAtcPop); });
      var atcChoose = atcPop.querySelector('[data-noux-atc-choose]');
      if (atcChoose) atcChoose.addEventListener('click', function () { atcPop.hidden = true; document.documentElement.classList.remove('np-drawer-open'); openDrawer({ type: 'main', idx: firstEmptySlot(tiers[selTier]) }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAtcPop(); });
    }

    // Swap the big gallery image to match the selected package
    function swapTierImage() {
      var imgs = data.tierImages || [];
      var url = imgs[selTier];
      if (!url || !window.nouxSwapMainImage) return;
      var label = (tiers[selTier] && tiers[selTier].name) ? tiers[selTier].name + ' kit' : '';
      window.nouxSwapMainImage(url, label);
      var active = document.querySelector('[data-noux-thumb].active');
      if (active) active.classList.remove('active');
      if (window.nouxTopBadgeSync) window.nouxTopBadgeSync();
    }

    render();
    // Note: no swapTierImage() on load — keep the first gallery image (noux-hero-1) as the
    // opening view. The package image only swaps in when a tier is actively selected.
    if (window.nouxTopBadgeSync) window.nouxTopBadgeSync();
  })();

  // ── Subscribe box WITHOUT bundle builder (refill page) ──
  (function () {
    if (document.querySelector('[data-noux-bundle]')) return; // bundle JS owns it there
    var dataEl = document.querySelector('[data-noux-bundle-data]');
    var subBox = document.querySelector('[data-noux-subscribe]');
    if (!dataEl || !subBox) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var subToggle = subBox.querySelector('[data-noux-sub-toggle]');
    var subPlan = subBox.querySelector('[data-noux-sub-plan]');
    var subPrice = subBox.querySelector('[data-noux-sub-price]');
    var subStrike = subBox.querySelector('[data-noux-sub-strike]');
    var form = document.getElementById('noux-product-form');
    var input = document.querySelector('[data-noux-variant-input]');
    var subInputWrap = form ? form.querySelector('[data-noux-sub-input]') : null;
    var priceEl = document.querySelector('[data-noux-price]');
    var strikeEl = document.querySelector('[data-noux-strike]');
    var saveEl = document.querySelector('[data-noux-save]');
    var ctaPrice = document.querySelector('[data-noux-cta-price]');
    var ctaStrike = document.querySelector('[data-noux-cta-strike]');

    var SB_CODE = (window.Shopify && Shopify.currency && Shopify.currency.active) || data.currencyCode || 'GBP';
    var SB_NF = null;
    try { SB_NF = new Intl.NumberFormat(nouxLocale(), { style: 'currency', currency: SB_CODE, currencyDisplay: 'narrowSymbol' }); }
    catch (e) { try { SB_NF = new Intl.NumberFormat(nouxLocale(), { style: 'currency', currency: SB_CODE }); } catch (e2) { SB_NF = null; } }
    function fmt(c) {
      var a = c / 100, s;
      if (SB_NF) { try { s = SB_NF.format(a); } catch (e) { s = (data.currency || '£') + a.toFixed(2); } }
      else s = (data.currency || '£') + a.toFixed(2);
      // Same rule as the buy box: only disambiguate an ambiguous "$".
      return (s.indexOf(SB_CODE) === -1 && s.indexOf('$') !== -1) ? (s + ' ' + SB_CODE) : s;
    }
    function active() { return !!(subToggle && subToggle.checked && subPlan && subPlan.value); }
    function variantById(id) { return data.variants.find(function (v) { return String(v.id) === String(id); }); }
    function alloc(vid, pid) {
      return (data.allocations || []).find(function (a) {
        return String(a.variantId) === String(vid) && String(a.planId) === String(pid);
      });
    }
    function render() {
      var v = input ? variantById(input.value) : null;
      if (!v) return;
      var a = active() ? alloc(v.id, subPlan.value) : null;
      var eff = a ? a.price : v.price;
      var cap = a ? v.price : v.cap;
      if (priceEl) priceEl.textContent = fmt(eff);
      if (strikeEl) { strikeEl.textContent = fmt(cap); strikeEl.style.display = cap > eff ? '' : 'none'; }
      if (saveEl) {
        if (cap > eff) { saveEl.style.display = ''; saveEl.textContent = data.savingsLabel + ' ' + fmt(cap - eff); }
        else saveEl.style.display = 'none';
      }
      if (ctaPrice) ctaPrice.textContent = fmt(eff);
      if (ctaStrike) { ctaStrike.textContent = fmt(cap); ctaStrike.style.display = cap > eff ? '' : 'none'; }
      var pa = subPlan && subPlan.value ? alloc(v.id, subPlan.value) : null;
      if (pa && subPrice) subPrice.textContent = fmt(pa.price);
      if (subStrike) subStrike.textContent = fmt(v.price);
      if (subInputWrap) {
        subInputWrap.innerHTML = '';
        if (active()) {
          var sp = document.createElement('input');
          sp.type = 'hidden'; sp.name = 'selling_plan'; sp.value = subPlan.value;
          subInputWrap.appendChild(sp);
        }
      }
      subBox.classList.toggle('active', active());
    }
    if (subToggle) subToggle.addEventListener('change', render);
    if (subPlan) subPlan.addEventListener('change', render);
    document.querySelectorAll('[data-noux-variants] [data-variant-id]').forEach(function (s) {
      s.addEventListener('click', function () { setTimeout(render, 0); });
    });
    render();
  })();

  // Qty stepper
  document.querySelectorAll('[data-noux-qty]').forEach(function (root) {
    var input = root.querySelector('input');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    var priceEl = document.querySelector('[data-noux-cta-price]');
    var unitPrice = priceEl ? parseFloat(priceEl.dataset.unit || '0') : 0;
    function update() {
      var n = Math.max(1, parseInt(input.value || '1', 10));
      input.value = n;
      if (priceEl && unitPrice) {
        var total = (unitPrice * n).toFixed(2).replace(/\.00$/, '');
        priceEl.textContent = nouxCurSymbol(priceEl.dataset.currency) + total;
      }
    }
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, parseInt(input.value || '1', 10) - 1); update(); });
    if (plus) plus.addEventListener('click', function () { input.value = parseInt(input.value || '1', 10) + 1; update(); });
    input.addEventListener('input', update);
  });

  // Product FAQ accordion (toggle current, close others)
  document.querySelectorAll('[data-noux-product-faq]').forEach(function (root) {
    var rows = root.querySelectorAll('.np-faq-row');
    rows.forEach(function (row, i) {
      var q = row.querySelector('.np-faq-q');
      if (!q) return;
      q.addEventListener('click', function () {
        var wasOpen = row.classList.contains('open');
        rows.forEach(function (x) { x.classList.remove('open'); });
        if (!wasOpen) row.classList.add('open');
      });
      if (i === 0) row.classList.add('open');
    });
  });

  // Reviews filter pills (visual only)
  document.querySelectorAll('[data-noux-review-filters]').forEach(function (root) {
    var pills = root.querySelectorAll('.np-reviews-filter');
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        pills.forEach(function (x) { x.classList.remove('active'); });
        p.classList.add('active');
      });
    });
  });

  // Feature-split: click a card to show its image large in the viewer
  document.querySelectorAll('.np-fsplit').forEach(function (sec) {
    var main = sec.querySelector('[data-fs-main]');
    var cards = sec.querySelectorAll('[data-fs-card]');
    if (!main || !cards.length) return;
    cards.forEach(function (c) {
      c.addEventListener('click', function () {
        var full = c.getAttribute('data-full');
        if (!full) return;
        main.removeAttribute('srcset');
        main.src = full;
        cards.forEach(function (x) { x.classList.remove('active'); });
        c.classList.add('active');
      });
    });
  });

  // "What you get with your kit" — tap a tile to open an info popup (what / does / why + image)
  (function () {
    var grid = document.querySelector('[data-noux-wyg-grid]');
    if (!grid) return;

    // Maniac-tone copy per kit item, keyed by lowercased name. Edit here to change popup text.
    // `usage` (optional) = a usage-photo asset URL; falls back to the tile image if empty.
    var INFO = {
      'uv led nail lamp': {
        what: 'A pocket-sized LED lamp that flash-cures your gel strips rock-hard in minutes. Folds flat, charges over USB, comes everywhere you do.',
        purpose: 'It cures the semi-cured gel, setting your strips to a glossy, chip-proof finish.',
        why: 'Skip the lamp and your strips stay tacky and peel by lunch. A quick zap under the light and you’ve got salon-hard nails that actually go the distance. This is the step that makes it gel, not sticker.'
      },
      'removal oil': {
        what: 'A gentle, nourishing oil that melts the bond so your strips slide right off.',
        purpose: 'It removes your gel strips. No acetone, no soaking, no scraping.',
        why: 'No ripping, no damage, no sad crispy nails. Brush it on, count to a hundred, peel off clean. Your natural nails stay strong and happy for the next set.'
      },
      'uv top coat': {
        what: 'The finishing gel that locks everything in with a wet, mirror-glass shine.',
        purpose: 'It seals the strip edges and adds that glossy salon top-layer.',
        why: 'Sealed edges mean longer wear and zero lifting at the tips. It’s the difference between “cute” and “wait, where did you get those done?”'
      },
      'linen bag': {
        what: 'A soft, reusable pouch that keeps your whole kit together in one cute spot.',
        purpose: 'It stores your lamp, oils and tools so nothing goes walkabout.',
        why: 'No more digging through drawers. Zip it up, toss it in your bag, and do touch-ups anywhere. (Also: it’s genuinely adorable.)'
      },
      'cuticle pusher': {
        what: 'A slim dual-ended tool that pushes back cuticles and preps the nail.',
        purpose: 'It creates a clean, dry surface so your strips grip for maximum wear.',
        why: 'A clean base is the whole secret to a mani that lasts. Push back the cuticles, sweep away the oils, and your strips will stick like they actually mean it.'
      },
      'scissor': {
        what: 'Tiny precision scissors made for trimming strips to size.',
        purpose: 'It snips strips to fit smaller nails and shape the tips.',
        why: 'A perfect fit is what separates “DIY” from “did you go to a salon?” Trim, shape, done. No overhang, no gaps, just nails that look custom (because now they are).'
      }
    };

    var pop = null;
    function close() { if (pop) { pop.hidden = true; document.documentElement.classList.remove('np-drawer-open'); } }
    function ensurePop() {
      if (pop) return;
      pop = document.createElement('div');
      pop.className = 'np-itempop';
      pop.hidden = true;
      pop.innerHTML = '<div class="np-itempop-overlay" data-noux-ip-close></div>'
        + '<div class="np-itempop-panel" role="dialog" aria-modal="true">'
        + '<button type="button" class="np-itempop-x" data-noux-ip-close aria-label="Close">&times;</button>'
        + '<div class="np-itempop-media"><img class="np-itempop-img" alt=""></div>'
        + '<div class="np-itempop-body">'
        + '<h3 class="np-itempop-name"></h3>'
        + '<div class="np-itempop-blocks"></div>'
        + '</div></div>';
      document.body.appendChild(pop);
      pop.querySelectorAll('[data-noux-ip-close]').forEach(function (c) { c.addEventListener('click', close); });
    }
    function blockHtml(label, text) {
      if (!text) return '';
      return '<div class="np-itempop-block"><span class="np-itempop-label">' + label + '</span><p>' + text + '</p></div>';
    }
    function openFor(card) {
      var im = card.querySelector('.np-wyg-img img');
      var name = ((card.querySelector('.np-wyg-name') || {}).textContent || '').trim();
      var info = INFO[name.toLowerCase()] || {};
      ensurePop();
      var imgEl = pop.querySelector('.np-itempop-img');
      var src = info.usage || (im && im.src);
      if (src) { imgEl.src = src; imgEl.alt = name; imgEl.style.display = ''; pop.querySelector('.np-itempop-media').style.display = ''; }
      else { pop.querySelector('.np-itempop-media').style.display = 'none'; }
      pop.querySelector('.np-itempop-name').textContent = name;
      pop.querySelector('.np-itempop-blocks').innerHTML =
        blockHtml('What is it?', info.what) +
        blockHtml('What it does', info.purpose) +
        blockHtml('Why you need it', info.why);
      pop.hidden = false;
      pop.querySelector('.np-itempop-panel').scrollTop = 0;
      document.documentElement.classList.add('np-drawer-open');
    }
    grid.addEventListener('click', function (e) {
      var card = e.target.closest('.np-wyg-card');
      if (card) openFor(card);
    });
    grid.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest('.np-wyg-card');
      if (card) { e.preventDefault(); openFor(card); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  })();

  // Review summary photo strip — click a photo to open a lightbox, browse with ‹ ›
  (function () {
    var strip = document.querySelector('[data-np-rev-photos]');
    if (!strip) return;
    var imgs = Array.prototype.slice.call(strip.querySelectorAll('.np-reviews-photo img'));
    if (!imgs.length) return;
    var srcs = imgs.map(function (i) { return i.getAttribute('src'); });
    var cur = 0, box = null;
    function close() { if (box) { box.hidden = true; document.documentElement.classList.remove('np-drawer-open'); } }
    function show(i) { cur = (i + srcs.length) % srcs.length; box.querySelector('.np-lightbox-img').src = srcs[cur]; }
    function ensureBox() {
      if (box) return;
      box = document.createElement('div');
      box.className = 'np-lightbox np-lightbox--nav';
      box.hidden = true;
      box.innerHTML = '<div class="np-lightbox-overlay" data-noux-lb-close></div>'
        + '<div class="np-lightbox-inner">'
        + '<button type="button" class="np-lightbox-x" data-noux-lb-close aria-label="Close">&times;</button>'
        + '<button type="button" class="np-lightbox-nav prev" data-lb-prev aria-label="' + nouxT('prev', 'Previous') + '">&lsaquo;</button>'
        + '<img class="np-lightbox-img" alt="Customer photo">'
        + '<button type="button" class="np-lightbox-nav next" data-lb-next aria-label="' + nouxT('next', 'Next') + '">&rsaquo;</button>'
        + '</div>';
      document.body.appendChild(box);
      box.querySelectorAll('[data-noux-lb-close]').forEach(function (c) { c.addEventListener('click', close); });
      box.querySelector('[data-lb-prev]').addEventListener('click', function (e) { e.stopPropagation(); show(cur - 1); });
      box.querySelector('[data-lb-next]').addEventListener('click', function (e) { e.stopPropagation(); show(cur + 1); });
    }
    strip.addEventListener('click', function (e) {
      var ph = e.target.closest('.np-reviews-photo');
      if (!ph) return;
      var idx = imgs.indexOf(ph.querySelector('img'));
      if (idx < 0) return;
      ensureBox(); show(idx); box.hidden = false;
      document.documentElement.classList.add('np-drawer-open');
    });
    document.addEventListener('keydown', function (e) {
      if (!box || box.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(cur - 1);
      else if (e.key === 'ArrowRight') show(cur + 1);
    });
  })();
})();

// ── Designs grid (/collections/shades): filter, pick, volume price, add all ──
(function () {
  var root = document.querySelector('[data-noux-designs]');
  if (!root) return;

  var grid    = root.querySelector('[data-noux-dg-grid]');
  var cards   = Array.prototype.slice.call(root.querySelectorAll('[data-noux-dg-card]'));
  var pills   = Array.prototype.slice.call(root.querySelectorAll('[data-dg-filter]'));
  var countEl = root.querySelector('[data-noux-dg-count]');
  var chosenEl= root.querySelector('[data-noux-dg-chosen]');
  var priceEl = root.querySelector('[data-noux-dg-price]');
  var hintEl  = root.querySelector('[data-noux-dg-hint]');
  var noteEl  = root.querySelector('[data-noux-dg-note]');
  var barEl   = root.querySelector('[data-noux-dg-bar]');
  var ctaEl   = root.querySelector('[data-noux-dg-cta]');
  var volRows = Array.prototype.slice.call(root.querySelectorAll('[data-noux-dg-volrow]'));

  var basePrice = parseInt(root.dataset.basePrice, 10) || 1490;
  // tiers: "minQty:pctOff|…" ascending by qty
  var tiers = (root.dataset.tiers || '1:0|2:10|3:20|5:27').split('|').map(function (t) {
    var p = t.split(':');
    return { qty: parseInt(p[0], 10) || 1, pct: parseFloat(p[1]) || 0 };
  }).sort(function (a, b) { return a.qty - b.qty; });

  // [{id, name, img, qty}] — qty so the same design can be added more than once.
  // Volume tiers price on TOTAL units, so `units()` (not picked.length) drives everything.
  var picked = [];
  function units() { return picked.reduce(function (a, p) { return a + p.qty; }, 0); }
  function entryFor(id) { for (var i = 0; i < picked.length; i++) if (picked[i].id === id) return picked[i]; return null; }

  // Money in the visitor's presentment currency (GBP base, EUR/… via Markets).
  var CODE = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  var NF = null;
  try { NF = new Intl.NumberFormat(Shopify.locale || undefined, { style: 'currency', currency: CODE, currencyDisplay: 'narrowSymbol' }); } catch (e) {}
  function money(cents) {
    var a = cents / 100;
    if (NF) { try { return NF.format(a); } catch (e) {} }
    return (CODE === 'GBP' ? '£' : '') + a.toFixed(2);
  }
  function unitFor(n) {
    var pct = 0;
    for (var i = 0; i < tiers.length; i++) if (n >= tiers[i].qty) pct = tiers[i].pct;
    // Shopify truncates the discount amount to whole minor units and subtracts it; it does
    // NOT round the resulting price. Mirroring that keeps displayed == charged in every
    // currency (27% of 1795 -> 484 off -> 1311, whereas rounding would show 1310).
    return basePrice - Math.floor(basePrice * pct / 100);
  }
  function nextTier(n) {
    for (var i = 0; i < tiers.length; i++) if (tiers[i].qty > n) return tiers[i];
    return null;
  }

  function render() {
    var n = units();
    var unit = unitFor(n);

    // chosen chips
    if (!n) {
      chosenEl.innerHTML = '<p class="dg-chosen-empty">' + nouxT('dg_empty', 'Nothing picked yet, start with one design') + '</p>';
    } else {
      var html = '<div class="dg-chosen-list">';
      picked.forEach(function (p, i) {
        html += '<span class="dg-chip">'
             +  (p.img ? '<img src="' + p.img + '" alt="">' : '')
             +  '<span class="dg-chip-name">' + p.name + '</span>'
             +  '<span class="dg-chip-step">'
             +    '<button type="button" data-dg-dec="' + i + '" aria-label="' + nouxT('dg_less', 'One less') + '">&minus;</button>'
             +    '<b data-dg-qty>' + p.qty + '</b>'
             +    '<button type="button" data-dg-inc="' + i + '" aria-label="' + nouxT('dg_more', 'One more') + '">+</button>'
             +  '</span>'
             +  '<button type="button" class="dg-chip-x" data-dg-drop="' + i + '" aria-label="' + nouxT('dg_remove', 'Remove') + '">&times;</button>'
             +  '</span>';
      });
      chosenEl.innerHTML = html + '</div>';
    }

    // headline price + hint
    priceEl.textContent = money(unit);
    hintEl.textContent = n
      ? (n === 1
          ? nouxT('dg_price_hint_one',  money(unit) + ' each · 1 design',            { price: money(unit), count: n })
          : nouxT('dg_price_hint_each', money(unit) + ' each · ' + n + ' designs',   { price: money(unit), count: n }))
      : nouxT('dg_price_hint_none', 'Pick your first design to see your price');

    // nudge note + progress toward the next tier
    var nt = nextTier(n);
    if (!n) {
      var t2 = tiers.filter(function (t) { return t.qty > 1; })[0];
      noteEl.textContent = nouxT('dg_note_none',
        'Pick your first design at ' + money(basePrice) + '. Two designs drop it to ' + money(unitFor(t2 ? t2.qty : 2)) + ' each.',
        { first: money(basePrice), next: money(unitFor(t2 ? t2.qty : 2)) });
      barEl.style.width = '0%';
    } else if (nt) {
      var need = nt.qty - n;
      noteEl.textContent = nouxT('dg_note_next',
        'Add ' + need + ' more to drop to ' + money(unitFor(nt.qty)) + ' each.',
        { n: need, next: money(unitFor(nt.qty)) });
      barEl.style.width = Math.round((n / nt.qty) * 100) + '%';
    } else {
      noteEl.textContent = nouxT('dg_note_best', 'Best price reached. ' + money(unit) + ' per design.', { price: money(unit) });
      barEl.style.width = '100%';
    }

    // highlight the active volume row
    var activeQty = 1;
    tiers.forEach(function (t) { if (n >= t.qty) activeQty = t.qty; });
    volRows.forEach(function (r) {
      r.setAttribute('data-active', (n > 0 && parseInt(r.dataset.qty, 10) === activeQty) ? '1' : '0');
    });

    // CTA
    if (!n) {
      ctaEl.textContent = nouxT('dg_cta_empty', 'CHOOSE A DESIGN');
      ctaEl.setAttribute('data-ready', '0');
    } else {
      var total = money(unit * n);
      ctaEl.textContent = n === 1
        ? nouxT('dg_cta_add_one', 'ADD 1 DESIGN · ' + total, { total: total })
        : nouxT('dg_cta_add', 'ADD ' + n + ' DESIGNS · ' + total, { count: n, total: total });
      ctaEl.setAttribute('data-ready', '1');
    }
  }

  // Reflect each card's quantity back onto the card itself, so the grid shows what's
  // in the set without scrolling to the panel.
  function syncCards() {
    cards.forEach(function (c) {
      var e = entryFor(c.dataset.variant);
      var q = e ? e.qty : 0;
      c.setAttribute('aria-pressed', q > 0 ? 'true' : 'false');
      var badge = c.querySelector('.dg-card-qty');
      if (q > 1) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'dg-card-qty';
          c.querySelector('.dg-card-media').appendChild(badge);
        }
        badge.textContent = '\u00d7' + q;
      } else if (badge) { badge.remove(); }
    });
  }

  // Add one unit. Clicking a card no longer un-picks it — the same design can be added
  // repeatedly, so removal lives on the chip stepper in the panel instead.
  function addCard(card, delta) {
    if (!card || card.disabled) return;
    var id = card.dataset.variant;
    var e = entryFor(id);
    if (e) {
      e.qty += (delta || 1);
      if (e.qty < 1) picked.splice(picked.indexOf(e), 1);
    } else if ((delta || 1) > 0) {
      var im = card.querySelector('img');
      picked.push({ id: id, name: card.dataset.name, img: im ? im.src : '', qty: 1 });
    }
    render();
    syncCards();
  }
  cards.forEach(function (card) {
    card.addEventListener('click', function () { addCard(card, 1); });
  });

  // ── preview lightbox ──
  // Same carousel as the picker drawer, reusing its .np-pv-* markup and CSS.
  var pv      = root.querySelector('[data-noux-dg-pv]');
  var pvBody  = root.querySelector('[data-noux-dg-pv-body]');
  var pvImgs  = [];
  var pvIdx   = 0;
  var pvCard  = null;

  function pvEsc(x) { return String(x == null ? '' : x)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  function pvSync() {
    if (pvIdx < 0) pvIdx = pvImgs.length - 1;
    if (pvIdx >= pvImgs.length) pvIdx = 0;
    pvBody.querySelectorAll('.np-pv-slide').forEach(function (el, k) { el.classList.toggle('on', k === pvIdx); });
    pvBody.querySelectorAll('.np-pv-dot').forEach(function (el, k) { el.classList.toggle('on', k === pvIdx); });
  }

  function pvOpen(btn) {
    if (!pv || !pvBody) return;
    pvCard = btn.parentElement.querySelector('[data-noux-dg-card]');
    pvImgs = (btn.dataset.imgs || '').split(',').filter(Boolean);
    if (!pvImgs.length) return;
    pvIdx = 0;
    var name = btn.dataset.name || '', desc = btn.dataset.desc || '';
    var multi = pvImgs.length > 1;
    var chosen = pvCard && pvCard.getAttribute('aria-pressed') === 'true';
    var soldOut = btn.dataset.out === '1';
    pvBody.innerHTML =
      '<div class="np-pv-stage">'
      + (multi ? '<button type="button" class="np-pv-arrow prev" data-noux-dg-pvprev aria-label="' + pvEsc(nouxT('prev','Previous')) + '">&lsaquo;</button>' : '')
      + '<div class="np-pv-slides">'
      + pvImgs.map(function (u, k) { return '<div class="np-pv-slide' + (k === 0 ? ' on' : '') + '"><img src="' + u + '" alt="' + pvEsc(name) + '" loading="lazy"></div>'; }).join('')
      + '</div>'
      + (multi ? '<button type="button" class="np-pv-arrow next" data-noux-dg-pvnext aria-label="' + pvEsc(nouxT('next','Next')) + '">&rsaquo;</button>' : '')
      + '</div>'
      + (multi ? '<div class="np-pv-dots">' + pvImgs.map(function (u, k) { return '<button type="button" class="np-pv-dot' + (k === 0 ? ' on' : '') + '" data-noux-dg-pvdot="' + k + '"></button>'; }).join('') + '</div>' : '')
      + '<h3 class="np-pv-name">' + pvEsc(name) + '</h3>'
      + (desc ? '<p class="np-pv-desc">' + pvEsc(desc) + '</p>' : '')
      + (soldOut
          ? '<button type="button" class="np-pv-select" disabled>' + pvEsc(nouxT('sold_out','Sold out')) + '</button>'
          : '<button type="button" class="np-pv-select" data-noux-dg-pvselect>'
            + pvEsc(chosen ? nouxT('dg_pv_add_another','+ Add another') : nouxT('pv_select','+ Select this design'))
            + '</button>')
      // Fabian asked for a route through to the individual product page, where a single
      // design can be bought on its own rather than as part of a set.
      + (btn.dataset.url
          ? '<a class="np-pv-link" href="' + btn.dataset.url + '">'
            + pvEsc(nouxT('dg_pv_product','View product page and buy just this one')) + ' &rsaquo;</a>'
          : '');
    pv.hidden = false;
    document.documentElement.classList.add('np-drawer-open');   // reuse the scroll lock
    pvBody.scrollTop = 0;
  }
  function pvClose() {
    if (!pv) return;
    pv.hidden = true;
    document.documentElement.classList.remove('np-drawer-open');
    pvCard = null;
  }

  if (grid) grid.addEventListener('click', function (e) {
    var b = e.target.closest('[data-noux-dg-prev]');
    if (b) { e.preventDefault(); e.stopPropagation(); pvOpen(b); }
  });
  if (pv) {
    pv.addEventListener('click', function (e) {
      if (e.target.closest('[data-noux-dg-pv-close]')) { pvClose(); return; }
      if (e.target.closest('[data-noux-dg-pvprev]')) { pvIdx--; pvSync(); return; }
      if (e.target.closest('[data-noux-dg-pvnext]')) { pvIdx++; pvSync(); return; }
      var d = e.target.closest('[data-noux-dg-pvdot]');
      if (d) { pvIdx = parseInt(d.getAttribute('data-noux-dg-pvdot'), 10); pvSync(); return; }
      if (e.target.closest('[data-noux-dg-pvselect]')) { addCard(pvCard, 1); pvClose(); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (pv.hidden) return;
      if (e.key === 'Escape') pvClose();
      if (e.key === 'ArrowLeft')  { pvIdx--; pvSync(); }
      if (e.key === 'ArrowRight') { pvIdx++; pvSync(); }
    });
  }

  // chip controls: fewer / more / remove entirely
  chosenEl.addEventListener('click', function (e) {
    var inc = e.target.closest('[data-dg-inc]');
    if (inc) { picked[parseInt(inc.dataset.dgInc, 10)].qty++; render(); syncCards(); return; }
    var dec = e.target.closest('[data-dg-dec]');
    if (dec) {
      var j = parseInt(dec.dataset.dgDec, 10);
      picked[j].qty--;
      if (picked[j].qty < 1) picked.splice(j, 1);
      render(); syncCards(); return;
    }
    var b = e.target.closest('[data-dg-drop]');
    if (!b) return;
    picked.splice(parseInt(b.dataset.dgDrop, 10), 1);
    render(); syncCards();
  });

  // colour filters
  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var f = pill.dataset.dgFilter;
      pills.forEach(function (p) { p.classList.toggle('active', p === pill); });
      var shown = 0;
      cards.forEach(function (c) {
        var on = (f === 'all') || (c.dataset.colour === f);
        c.style.display = on ? '' : 'none';
        if (on) shown++;
      });
      countEl.textContent = nouxT('dg_count', shown + ' DESIGNS', { count: shown });
    });
  });

  // add every picked design to the cart
  ctaEl.addEventListener('click', function () {
    if (!picked.length) {
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    ctaEl.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: picked.map(function (p) { return { id: parseInt(p.id, 10), quantity: p.qty }; }) })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';
    }).catch(function () { ctaEl.disabled = false; });
  });

  render();
})();

// ── Starter Kit PDP v2: fixed kit, N chosen designs ──
(function () {
  var root = document.querySelector('[data-noux-kit]');
  if (!root) return;

  var want     = parseInt(root.dataset.want, 10) || 3;
  var variant  = root.dataset.variant;
  var price    = parseInt(root.dataset.price, 10) || 0;
  var slotsEl  = root.querySelector('[data-noux-kit-slots]');
  var countEl  = root.querySelector('[data-noux-kit-count]');
  var atcEl    = root.querySelector('[data-noux-kit-atc]');
  var mainImg  = root.querySelector('[data-noux-kit-img]');

  // The picker is the same drawer component as the live PDP (same np-* classes, same CSS),
  // just bound to kit-scoped data hooks so the two never share DOM.
  var picker    = root.querySelector('[data-noux-kit-drawer]');
  var pickGrid  = root.querySelector('[data-noux-kit-drawer-grid]');
  var pickFilt  = root.querySelector('[data-noux-kit-drawer-filters]');
  var pickBody  = root.querySelector('[data-noux-kit-drawer-body]');
  var pickNum   = root.querySelector('[data-noux-kit-drawer-num]');
  var pvWrap    = root.querySelector('[data-noux-kit-preview]');
  var pvBack    = root.querySelector('[data-noux-kit-preview-back]');

  var shades = [];
  try { shades = JSON.parse(root.querySelector('[data-noux-kit-shades]').textContent) || []; } catch (e) {}

  var picks = new Array(want).fill(null);
  var target = 0;

  var CODE = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  var NF = null;
  try { NF = new Intl.NumberFormat(Shopify.locale || undefined, { style: 'currency', currency: CODE, currencyDisplay: 'narrowSymbol' }); } catch (e) {}
  function money(c) { var a = c / 100; if (NF) { try { return NF.format(a); } catch (e) {} } return a.toFixed(2); }

  function chosen() { return picks.filter(Boolean).length; }

  function render() {
    var n = chosen();
    countEl.textContent = nouxT('kit_slots_count', n + ' OF ' + want + ' CHOSEN', { n: n, total: want });

    picks.forEach(function (p, i) {
      var btn = slotsEl.querySelector('[data-noux-kit-slot="' + (i + 1) + '"]');
      if (!btn) return;
      var old = btn.parentElement.querySelector('.kt-slot-x');
      if (old) old.remove();
      if (p) {
        btn.classList.add('filled');
        btn.innerHTML = '<img src="' + p.img + '" alt="' + p.name.replace(/"/g, '&quot;') + '">';
        var x = document.createElement('button');
        x.type = 'button'; x.className = 'kt-slot-x'; x.innerHTML = '&times;';
        x.setAttribute('data-noux-kit-drop', String(i));
        btn.parentElement.appendChild(x);
      } else {
        btn.classList.remove('filled');
        btn.innerHTML = '<span class="kt-slot-plus" aria-hidden="true">+</span>';
      }
    });

    // The label is constant, as in the mockup: "ADD TO CART · <price>" even at 0 of 3.
    // data-ready still tracks completeness — the click handler uses it to open the picker
    // instead of adding to cart when designs are still missing.
    atcEl.textContent = nouxT('kit_atc', 'ADD TO CART · ' + money(price), { amount: money(price) });
    atcEl.setAttribute('data-ready', n === want ? '1' : '0');
  }

  nouxTagShades(shades);
  var fColour = null, fEffect = null;
  var pvIdx = 0, pvShade = -1;

  function esc(x) { return String(x == null ? '' : x).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function renderFilters() {
    if (!pickFilt) return;
    // Only offer a filter that actually has designs behind it.
    var cP = {}, eP = {};
    shades.forEach(function (s) { cP[s._c] = 1; eP[s._e] = 1; });
    var c = '<span class="np-df-label">' + nouxT('filter_colour', 'Colour') + '</span><span class="np-df-row">';
    NOUX_COLOURS.forEach(function (x) {
      if (!cP[x[0]]) return;
      c += '<button type="button" class="np-df-colour' + (fColour === x[0] ? ' active' : '') + '" data-noux-kit-fcolour="' + x[0] + '" title="' + esc(x[1]) + '" style="background:' + x[2] + '"><span class="visually-hidden">' + esc(x[1]) + '</span></button>';
    });
    c += '</span>';
    var e = '<span class="np-df-label">' + nouxT('filter_effect', 'Effect') + '</span><span class="np-df-row">';
    NOUX_EFFECTS.forEach(function (x) {
      if (!eP[x[0]]) return;
      e += '<button type="button" class="np-df-effect' + (fEffect === x[0] ? ' active' : '') + '" data-noux-kit-feffect="' + x[0] + '">' + esc(nouxT('effect_' + x[0], x[1])) + '</button>';
    });
    e += '</span>';
    pickFilt.innerHTML = '<div class="np-df-group">' + c + '</div><div class="np-df-group">' + e + '</div>';
  }

  function renderGrid() {
    if (!pickGrid) return;
    var used = picks.filter(Boolean).map(function (p) { return p.name; });
    var current = picks[target] ? picks[target].name : null;
    var list = shades.filter(function (s) {
      if (fColour && s._c !== fColour) return false;
      if (fEffect && s._e !== fEffect) return false;
      return true;
    });
    if (!list.length) {
      pickGrid.innerHTML = '<p class="np-drawer-empty">' + nouxT('no_match', 'No designs match these filters.') + '</p>';
      return;
    }
    pickGrid.innerHTML = list.map(function (s) {
      var i = shades.indexOf(s);
      var taken = used.indexOf(s.name) > -1 && current !== s.name;
      var soldOut = s.available === false;
      var off = soldOut || taken;
      var media = s.img
        ? '<span class="np-drawer-tile-media"><img class="np-drawer-tile-img" src="' + s.img + '" alt="' + esc(s.name) + '" loading="lazy"></span>'
        : '<span class="np-drawer-tile-media"><span class="np-drawer-tile-swatch" style="background:' + s.hex + '"></span></span>';
      var badge = '';
      if (soldOut) badge = '<span class="np-drawer-tile-stock out">' + nouxT('sold_out', 'Sold out') + '</span>';
      else if (taken) badge = '<span class="np-drawer-tile-stock">' + nouxT('kit_in_kit', 'In your kit') + '</span>';
      else if (s.badge) badge = '<span class="np-drawer-tile-badge np-drawer-tile-badge--' + (String(s.badge).toLowerCase().indexOf('just') === 0 ? 'new' : 'best') + '">' + esc(s.badge) + '</span>';
      return '<div class="np-drawer-cell' + (current === s.name ? ' active' : '') + (off ? ' sold-out' : '') + '">'
        + '<button type="button" class="np-drawer-tile" data-noux-kit-pick="' + i + '"' + (off ? ' disabled' : '') + '>'
        + media + badge
        + '<span class="np-drawer-tile-name">' + esc(s.name) + '</span></button>'
        + '<button type="button" class="np-drawer-preview-btn" data-noux-kit-prev="' + i + '"><span class="np-drawer-prev-ic" aria-hidden="true">&#8981;</span> ' + nouxT('preview', 'Preview') + '</button>'
        + '</div>';
    }).join('');
  }

  function openPreview(i) {
    var s = shades[i];
    if (!s || !pvWrap) return;
    pvShade = i; pvIdx = 0;
    var imgs = (s.imgs && s.imgs.length) ? s.imgs : [s.img];
    var slides = imgs.map(function (u, k) { return '<div class="np-pv-slide' + (k === 0 ? ' on' : '') + '"><img src="' + u + '" alt="' + esc(s.name) + '" loading="lazy"></div>'; }).join('');
    var dots = imgs.length > 1 ? imgs.map(function (u, k) { return '<button type="button" class="np-pv-dot' + (k === 0 ? ' on' : '') + '" data-noux-kit-pvdot="' + k + '"></button>'; }).join('') : '';
    pvWrap.innerHTML =
      '<div class="np-pv-stage">'
      + (imgs.length > 1 ? '<button type="button" class="np-pv-arrow prev" data-noux-kit-pvprev aria-label="' + esc(nouxT('prev', 'Previous')) + '">&lsaquo;</button>' : '')
      + '<div class="np-pv-slides">' + slides + '</div>'
      + (imgs.length > 1 ? '<button type="button" class="np-pv-arrow next" data-noux-kit-pvnext aria-label="' + esc(nouxT('next', 'Next')) + '">&rsaquo;</button>' : '')
      + '</div>'
      + (dots ? '<div class="np-pv-dots">' + dots + '</div>' : '')
      + '<h3 class="np-pv-name">' + esc(s.name) + '</h3>'
      + (s.desc ? '<p class="np-pv-desc">' + esc(s.desc) + '</p>' : '')
      + '<button type="button" class="np-pv-select" data-noux-kit-pvselect>' + nouxT('pv_select', '+ Select this design') + '</button>';
    if (pickBody) pickBody.hidden = true;
    pvWrap.hidden = false;
    if (pvBack) pvBack.hidden = false;
    pvWrap.scrollTop = 0;
  }
  function updatePreview() {
    if (pvShade < 0) return;
    var s = shades[pvShade];
    var imgs = (s.imgs && s.imgs.length) ? s.imgs : [s.img];
    if (pvIdx < 0) pvIdx = imgs.length - 1;
    if (pvIdx >= imgs.length) pvIdx = 0;
    pvWrap.querySelectorAll('.np-pv-slide').forEach(function (el, k) { el.classList.toggle('on', k === pvIdx); });
    pvWrap.querySelectorAll('.np-pv-dot').forEach(function (el, k) { el.classList.toggle('on', k === pvIdx); });
  }
  function closePreview() {
    if (pvWrap) pvWrap.hidden = true;
    if (pickBody) pickBody.hidden = false;
    if (pvBack) pvBack.hidden = true;
    pvShade = -1;
  }

  function openPicker(idx) {
    target = idx;
    if (pickNum) pickNum.textContent = nouxT('drawer_design', '· Design ' + (idx + 1), { n: idx + 1 });
    closePreview();
    renderFilters();
    renderGrid();
    picker.hidden = false;
    document.documentElement.classList.add('np-drawer-open');
  }
  function closePicker() {
    closePreview();
    picker.hidden = true;
    document.documentElement.classList.remove('np-drawer-open');
  }

  function pickShade(i) {
    var s = shades[i];
    if (!s || s.available === false) return;
    picks[target] = { name: s.name, img: s.img };
    closePicker();
    render();
    // jump to the next empty slot so picking three feels continuous
    var next = picks.indexOf(null);
    if (next > -1) setTimeout(function () { openPicker(next); }, 260);
  }

  if (pickFilt) pickFilt.addEventListener('click', function (e) {
    var c = e.target.closest('[data-noux-kit-fcolour]');
    if (c) { var v = c.getAttribute('data-noux-kit-fcolour'); fColour = (fColour === v) ? null : v; renderFilters(); renderGrid(); return; }
    var ef = e.target.closest('[data-noux-kit-feffect]');
    if (ef) { var w = ef.getAttribute('data-noux-kit-feffect'); fEffect = (fEffect === w) ? null : w; renderFilters(); renderGrid(); return; }
  });
  if (pvWrap) pvWrap.addEventListener('click', function (e) {
    if (e.target.closest('[data-noux-kit-pvprev]')) { pvIdx--; updatePreview(); return; }
    if (e.target.closest('[data-noux-kit-pvnext]')) { pvIdx++; updatePreview(); return; }
    var dot = e.target.closest('[data-noux-kit-pvdot]');
    if (dot) { pvIdx = parseInt(dot.getAttribute('data-noux-kit-pvdot'), 10); updatePreview(); return; }
    if (e.target.closest('[data-noux-kit-pvselect]')) { pickShade(pvShade); return; }
  });
  if (pvBack) pvBack.addEventListener('click', closePreview);

  slotsEl.addEventListener('click', function (e) {
    var drop = e.target.closest('[data-noux-kit-drop]');
    if (drop) { picks[parseInt(drop.dataset.nouxKitDrop, 10)] = null; render(); return; }
    var slot = e.target.closest('[data-noux-kit-slot]');
    if (slot) openPicker(parseInt(slot.dataset.nouxKitSlot, 10) - 1);
  });

  pickGrid.addEventListener('click', function (e) {
    var pv = e.target.closest('[data-noux-kit-prev]');
    if (pv) { openPreview(parseInt(pv.getAttribute('data-noux-kit-prev'), 10)); return; }
    var pk = e.target.closest('[data-noux-kit-pick]');
    if (pk) { pickShade(parseInt(pk.getAttribute('data-noux-kit-pick'), 10)); return; }
  });

  root.querySelectorAll('[data-noux-kit-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closePicker);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || picker.hidden) return;
    if (pvShade > -1) closePreview(); else closePicker();
  });

  // ── gallery: thumbs (images + video) and the play-overlay button ──
  // The video thumb swaps the main frame for a <video>; picking any image thumb afterwards
  // has to put the <img> back, so the frame is rebuilt rather than mutated in place.
  var stage = root.querySelector('.kt-main-img');

  // ── frame overlays (save badge + "see how it works") ──
  // Images after the first are infographics with copy baked in, so a floating badge
  // covers real text. Show the overlays on the first image only, and let the shopper
  // dismiss either one outright; a dismissal sticks for the rest of the visit.
  //
  // syncOverlays is the ONLY thing allowed to set .hidden on an overlay. showImage used to
  // clear it directly and, running after syncOverlays in the thumb handler, it resurrected
  // a pill the shopper had just dismissed and showed it over infographic frames too.
  var overlays = [].slice.call(root.querySelectorAll('[data-noux-kit-ov]'));
  var dismissed = {};
  var galIdx = 0;
  var frameIsVideo = false;

  function syncOverlays() {
    overlays.forEach(function (el) {
      var key = el.getAttribute('data-noux-kit-ov');
      el.hidden = frameIsVideo || (galIdx !== 0) || dismissed[key] === true;
    });
  }
  root.querySelectorAll('[data-noux-kit-ov-x]').forEach(function (x) {
    x.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();           // don't trigger the video button underneath
      dismissed[x.getAttribute('data-noux-kit-ov-x')] = true;
      syncOverlays();
    });
  });
  syncOverlays();

  function showImage(src) {
    var img = stage.querySelector('[data-noux-kit-img]');
    if (!img) {
      var v = stage.querySelector('video');
      if (v) { v.pause(); v.remove(); }
      img = document.createElement('img');
      img.setAttribute('data-noux-kit-img', '');
      img.alt = '';
      img.loading = 'eager';
      stage.insertBefore(img, stage.firstChild);
      mainImg = img;
    }
    img.src = src;
    frameIsVideo = false;
    syncOverlays();
  }

  function showVideo(src) {
    var img = stage.querySelector('[data-noux-kit-img]');
    if (img) img.remove();
    var old = stage.querySelector('video');
    if (old) old.remove();
    var v = document.createElement('video');
    v.src = src; v.controls = true; v.autoplay = true; v.playsInline = true; v.muted = true;
    stage.insertBefore(v, stage.firstChild);
    frameIsVideo = true;
    syncOverlays();
  }

  var thumbList = [].slice.call(root.querySelectorAll('[data-noux-kit-thumb]'));
  thumbList.forEach(function (t, i) {
    t.addEventListener('click', function () {
      thumbList.forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      galIdx = i;
      syncOverlays();
      if (!t.dataset.full) return;
      if (t.dataset.video === '1') showVideo(t.dataset.full);
      else showImage(t.dataset.full);
    });
  });

  // The "see how it works" pill now opens the shared lightbox (see nouxVideoLightbox at
  // the foot of this file) rather than swapping the clip into the gallery frame — the
  // frame is only ~380px tall on mobile and the clip's burnt-in subtitles are unreadable
  // at that size. Nothing kit-specific is left to wire up here.

  // rolling countdown, same 8h window pattern as the old PDP
  var cd = root.querySelector('[data-noux-kit-countdown]');
  if (cd) {
    var KEY = 'nouxKitDeadline';
    var end = parseInt(localStorage.getItem(KEY) || '0', 10);
    if (!end || end < Date.now()) { end = Date.now() + 8 * 3600 * 1000; try { localStorage.setItem(KEY, String(end)); } catch (e) {} }
    (function tick() {
      var d = Math.max(0, end - Date.now());
      var h = Math.floor(d / 3600000), m = Math.floor(d % 3600000 / 60000), s = Math.floor(d % 60000 / 1000);
      cd.textContent = [h, m, s].map(function (x) { return String(x).padStart(2, '0'); }).join(':');
      setTimeout(tick, 1000);
    })();
  }

  atcEl.addEventListener('click', function () {
    if (chosen() < want) {
      var next = picks.indexOf(null);
      openPicker(next > -1 ? next : 0);
      return;
    }
    var props = {};
    picks.forEach(function (p, i) { props['Design ' + (i + 1)] = p.name; });  // keys stay English for fulfilment
    atcEl.disabled = true;
    fetch('/cart/clear.js', { method: 'POST' }).then(function () {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variant, 10), quantity: 1, properties: props }] })
      });
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'checkout';
    }).catch(function () { atcEl.disabled = false; });
  });

  render();
})();

/* ── shared "see how it works" lightbox ────────────────────────────────────────────
   Used by both PDPs: A (noux-product-main) and B (noux-kit-main) render the same
   snippets/noux-video-modal.liquid and any number of snippets/noux-video-pill.liquid
   openers. Wiring lives here, at document level, so neither section owns it.

   The clip is attached on open and detached on close. That keeps the ~1.4MB file off
   the initial page load — most shoppers never press play — and guarantees audio can't
   keep running behind a dismissed dialog. */
(function nouxVideoLightbox() {
  function init() {
    var modal = document.querySelector('[data-noux-vm]');
    var video = modal && modal.querySelector('[data-noux-vm-video]');
    if (!modal || !video) return;

    function open(src) {
      if (src && video.getAttribute('src') !== src) video.setAttribute('src', src);
      modal.hidden = false;
      document.documentElement.classList.add('np-drawer-open');
      var p = video.play();
      // the click is a user gesture so sound is allowed, but a refusal must not throw
      if (p && p.catch) p.catch(function () {});
    }
    function close() {
      video.pause();
      video.removeAttribute('src');
      video.load();            // drops the buffered file instead of leaving it decoding
      modal.hidden = true;
      document.documentElement.classList.remove('np-drawer-open');
    }

    document.querySelectorAll('[data-noux-vm-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open(btn.getAttribute('data-src'));
      });
    });
    modal.querySelectorAll('[data-noux-vm-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* A's gallery pill: first-frame-only + dismiss (B's runs through the kt overlay system).
   Mirrors syncOverlays there — one function owns .hidden, and a dismissal outranks the
   frame index, so once the shopper closes the pill it stays closed for the visit even
   when they browse back to the first image. */
(function nouxGalleryPill() {
  function init() {
    var ov = document.querySelector('[data-noux-gal-ov]');
    if (!ov) return;
    var dismissed = false;
    var galIdx = 0;

    function sync() { ov.hidden = dismissed || galIdx !== 0; }

    var x = ov.querySelector('[data-noux-gal-ov-x]');
    if (x) x.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();     // don't open the video underneath
      dismissed = true;
      sync();
    });
    // images 2+ carry baked-in copy, so the pill only belongs on the first frame
    document.querySelectorAll('[data-noux-thumb]').forEach(function (t, i) {
      t.addEventListener('click', function () { galIdx = i; sync(); });
    });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Meta-LP comparison switcher: swaps which pre-rendered table is visible. Both tables
   ship in the HTML (see sections/noux-mlp-compare.liquid) so this only toggles [hidden]. */
(function nouxCompareSwitcher() {
  function init() {
    var tabs = [].slice.call(document.querySelectorAll('[data-noux-cmp-tab]'));
    if (!tabs.length) return;
    var panels = [].slice.call(document.querySelectorAll('[data-noux-cmp-panel]'));
    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var want = btn.getAttribute('data-noux-cmp-tab');
        tabs.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-noux-cmp-panel') !== want;
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
